export default __webpack_public_path__ + "static/media/banner2.7f46e01a.jpg";